/**
 * HttpClient blob responses can be Zone.js-wrapped in production builds.
 * Native APIs such as URL.createObjectURL throw "Illegal invocation" on them.
 */
export function toNativeBlob(blob: Blob, mimeType = 'application/pdf'): Blob {
  return new Blob([blob], { type: mimeType });
}
